import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VHover,{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c(VCard,{staticClass:"mx-auto",style:({
                border: '1px solid ' + _vm.servicio.color + ' !important'
            }),attrs:{"elevation":hover ? 24 : 6,"max-width":"344","shaped":""},on:{"click":function($event){if(_vm.servicio.idServicio != 219){
              _vm.goUrlServicio(
                    _vm.servicio.url,
                    _vm.servicio.idServicio,
                    _vm.servicio.claveServicio
                )
            }}}},[_c(VCardTitle,{staticStyle:{"flex-wrap":"nowrap"}},[_c(VFlex,{key:'sl_serv_icon_' + _vm.servicio.idServicio,attrs:{"xs12":"","text-center":""}},[_c(VIcon,{style:({
                            color: _vm.servicio.color + ' !important',
                            fontSize: '65px',
                            margin: '0 auto!important'
                        }),attrs:{"x-large":"","cols":"12","xs":"12"}},[_vm._v("\n                        "+_vm._s(_vm.servicio.iconoMui)+"\n                    ")])],1),_c(VFlex,{key:'sl_serv_txt_' + _vm.servicio.idServicio,attrs:{"xs12":"","text-center":""}},[_c('p',{staticClass:"text-center",style:({
                            color: _vm.servicio.color + ' !important',
                            margin: '0 auto!important',
                            fontSize: '1rem!important',
                            wordBreak: 'break-word',
                            lineHeight: '1rem!important',
                            fontWeight: '300!important'
                        })},[_vm._v("\n                        "+_vm._s(_vm.servicio.descripcion)+"\n                    ")])])],1),(_vm.idEstatus == 4)?_c(VCardActions,[_c(VFlex,{attrs:{"xs12":"","text-center":""}},[(_vm.loading)?_c(VSkeletonLoader,{attrs:{"type":"text"}}):_vm._e(),_c(VBtn,{style:({
                            color: _vm.servicio.color + ' !important'
                        }),attrs:{"text":""},on:{"click":function($event){return _vm.goSolicitudServicio()}}},[_c(VIcon,{staticClass:"mr-2"},[_vm._v("mdi-alert")]),_vm._v("\n                    Revisar información")],1),_vm._v("\n                        "+_vm._s(_vm.error)+"\n                    ")],1)],1):_vm._e()],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }